import React, { useEffect } from 'react'
import { userChallenges } from '../../actions/userActions'
import { connect } from 'react-redux'
import inMemoryJWT from '../../auth/inMemoryJwt';
import localStorage from '../../utils/hooks/useLocalStorage';

const SeeMyChallenges = ({ match, isLoadingListUserChallenges, listUserChallenges, userChallenges, history }) => {

    console.log()

    useEffect(() => {
        if (!(inMemoryJWT.getToken())) {
            inMemoryJWT.getRefreshedToken()
        }

        inMemoryJWT.waitForTokenRefresh().then(() => {
            userChallenges(match.params.userID)
        })

    }, [])

    console.log()
    return (
        <div className="mt-5 pb-5">
            <div className="wrapper-4 column-gap row-gap">
                {isLoadingListUserChallenges ? <div>Cargando...</div> :
                    listUserChallenges.map((challenge, index) => (
                        <div key={challenge._id} className="card-award">
                            <div className="content-img-award">
                                <img className="img-card-award" src={challenge.award.image}></img>
                            </div>
                            <div className="content-footer-award">
                                <div className="parent-inherit">{challenge.award.name}</div>
                                <div className="parent-width row endItems">{challenge.scrore}</div>
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}
const mapStateToProps = (state) => {
    return {
        isLoadingListUserChallenges: state.userInfo.isLoadingListUserChallenges,
        listUserChallenges: state.userInfo.listUserChallenges,
    }
}
export default connect(mapStateToProps, { userChallenges })(SeeMyChallenges)
